'use strict';
import * as $j_app$002edata$002etypes$005fchat$0024package$0024$002dChat$002dId$0024 from "./app.data.types_chat$package$-Chat-Id$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_PharmacyAppUpdate$$anon$99() {
}
export { $c_Lapp_api_PharmacyAppUpdate$$anon$99 as $c_Lapp_api_PharmacyAppUpdate$$anon$99 };
$c_Lapp_api_PharmacyAppUpdate$$anon$99.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_PharmacyAppUpdate$$anon$99.prototype.constructor = $c_Lapp_api_PharmacyAppUpdate$$anon$99;
/** @constructor */
function $h_Lapp_api_PharmacyAppUpdate$$anon$99() {
}
export { $h_Lapp_api_PharmacyAppUpdate$$anon$99 as $h_Lapp_api_PharmacyAppUpdate$$anon$99 };
$h_Lapp_api_PharmacyAppUpdate$$anon$99.prototype = $c_Lapp_api_PharmacyAppUpdate$$anon$99.prototype;
$c_Lapp_api_PharmacyAppUpdate$$anon$99.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_api_PharmacyAppUpdate$$anon$99.prototype.apply__O = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_prelude_tapir$package$().given_Schema_NonEmptySet__Lsttp_tapir_Schema__Lsttp_tapir_Schema($j_app$002edata$002etypes$005fchat$0024package$0024$002dChat$002dId$0024.$m_Lapp_data_types\uff3fchat$package$ChatId$().given_Schema_Type__Lsttp_tapir_Schema());
});
var $d_Lapp_api_PharmacyAppUpdate$$anon$99 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_PharmacyAppUpdate$$anon$99, "app.api.PharmacyAppUpdate$$anon$99", ({
  Lapp_api_PharmacyAppUpdate$$anon$99: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_api_PharmacyAppUpdate$$anon$99 as $d_Lapp_api_PharmacyAppUpdate$$anon$99 };
//# sourceMappingURL=app.api.-Pharmacy-App-Update$$anon$99.js.map
